import { EntDirectoryInfoName } from "./directoryInfoName";
import { EntGovernment } from "./handBooks/government";
import { EntTerritorialsUnits } from "./handBooks/territorialsUnits";

export class EntRealEstate {
  id: number | null = null;
  codeEni: string | null = null;
  territorialUnit: EntTerritorialsUnits | null = null;
  street: string | null = null;
  periodStart: string | null = null;
  periodEnd: string | null = null;
  houseNumber: string | null = null;
  longitude: number | undefined = undefined;
  latitude: number | undefined = undefined;
  square: number | null = null;
  unitMeasurement: EntDirectoryInfoName | null = null;
  unitMeasurementId: number | null = null;
  typeObjectId: number | null = null;
  typeObject: EntDirectoryInfoName | null = null;
  purposeObjectId: number | null = null;
  purposeObject: EntDirectoryInfoName | null = null;
  ownershipTypeId: number | null = null;
  ownershipType: EntDirectoryInfoName | null = null;
  landCategoryId: number | null = null;
  landCategory: EntDirectoryInfoName | null = null;
  conditionId: number | null = null;
  condition: EntDirectoryInfoName | null = null;
  description: string | null = null;
  government: EntGovernment | null = null;
  governmentId: number | null = null;
  territorialUnitId: number | null = null;

  territorialUnitArea:EntTerritorialsUnits | null = null;
  territorialUnitRegion:EntTerritorialsUnits | null = null;

  regionId: number | null = null
  areaId: number | null = null
}